import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

class GoogleCaptcha extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            componentLoaded: false,
        };
        if (typeof window !== "undefined") {
            window.captchaVerifyCallback = this.captchaVerifyCallback;
            window.captchaExpiredCallback = this.captchaExpiredCallback;
            window.captchaLoadCallback = this.captchaLoadCallback;
            this.state = {
                componentLoaded: true,
            };
        }
    }

    componentDidMount() {
        this.setState({ componentLoaded: true });
    }

    captchaLoadCallback = () => {
        this.props.captchaLoadCallback();
    };

    captchaVerifyCallback = captcha => {
        this.props.captchaVerifyCallback(captcha);
    };

    captchaExpiredCallback = () => {
        this.props.captchaExpiredCallback();
    };

    ResetCaptcha() {
        window.grecaptcha.reset();
    }

    execute() {
        window.grecaptcha.reset();
        window.grecaptcha.execute();
    }

    render() {
        return (
            <>
                {this.state.componentLoaded && (
                    <Helmet>
                        <script
                            src={`https://www.google.com/recaptcha/api.js?onload=captchaLoadCallback`}
                        ></script>
                    </Helmet>
                )}
                <div
                    className="g-recaptcha"
                    data-sitekey={this.props.siteKey}
                    data-callback="captchaVerifyCallback"
                    data-size={this.props.type}
                    id="captcha"
                    data-expired-callback="captchaExpiredCallback"
                />
            </>
        );
    }
}

GoogleCaptcha.defaultProps = {
    captchaLoadCallback: () => {},
    captchaExpiredCallback: () => {},
    type: "normal",
};

GoogleCaptcha.propTypes = {
    captchaLoadCallback: PropTypes.func,
    captchaVerifyCallback: PropTypes.func.isRequired,
    captchaExpiredCallback: PropTypes.func,
    siteKey: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["normal", "compact", "invisible"]),
};

export default GoogleCaptcha;
